import { Observable } from 'rxjs';

import { MgmtDept, MgmtDeptRestriction } from '../models/mgmt-dept.model';

export abstract class MgmtDeptUsecase {
  abstract get mgmtDept$(): Observable<MgmtDept>;

  abstract updateMgmtDeptRestriction(restriction: MgmtDeptRestriction): Observable<never>;
}
